import { render, staticRenderFns } from "./OcojoContentsTool.vue?vue&type=template&id=61fa94ee&scoped=true&"
import script from "./OcojoContentsTool.vue?vue&type=script&lang=ts&"
export * from "./OcojoContentsTool.vue?vue&type=script&lang=ts&"
import style0 from "./OcojoContentsTool.vue?vue&type=style&index=0&id=61fa94ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa94ee",
  null
  
)

export default component.exports